/**
* @summary - Component that Provides Work Group Creation Page
* @author Aro J
* @since 2024-06-10
*/
import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import WorkGroupList from '../../components/workgroupcomponents/WorkGroupList'
import Licensetypecodelist from '../../components/licensetypecodecomponents/Licensetypecodelist'

function LicenseTypeCodeDetails({renderPageContent}) {
    return (
        <>
                        <Licensetypecodelist renderPageContent={renderPageContent}/>
                     

        </>
    )
}
        
export default LicenseTypeCodeDetails;